import { render, staticRenderFns } from "./DeactivateIcon.vue?vue&type=template&id=2d904bab&"
import script from "./DeactivateIcon.vue?vue&type=script&lang=js&"
export * from "./DeactivateIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports